import _objectWithoutProperties from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty"; /**
                                                                                                                                                       * 通用的表格操作项组件
                                                                                                                                                       * */
import React from 'react';
var AdaptiveCell = /*#__PURE__*/function (_React$Component) {
  _inherits(AdaptiveCell, _React$Component);
  function AdaptiveCell() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, AdaptiveCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AdaptiveCell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      editing: false
    });
    return _this;
  }
  _createClass(AdaptiveCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        editable = _this$props.editable,
        dataIndex = _this$props.dataIndex,
        title = _this$props.title,
        record = _this$props.record,
        index = _this$props.index,
        restProps = _objectWithoutProperties(_this$props, ["editable", "dataIndex", "title", "record", "index"]);
      return /*#__PURE__*/React.createElement("td", restProps);
    }
  }]);
  return AdaptiveCell;
}(React.Component);
export { AdaptiveCell };